import { View, Modal,} from 'react-native-web'
import  {useState } from 'react'
import { CardModal} from '../../../../../element/Card'
import { Body, SubTitle, Title } from '../../../../../element/Text'
import { ButtonBlack, ButtonUser } from '../../../../../element/Button'


const CharacterSave = props =>{
 const [modalv, setModalv]= useState(props.modalv)


    return(
            <Modal
            visible={modalv}
            transparent={true}
            animationType={'slide'}
            key={props.key}
            style={{width:'100%', height:'100%',shadowOffset:{width:10, height:5}, shadowRadius:10, shadowOpacity:0.5,}}>
                         
                         <View style={{width:'100%', height:'100%', alignItems:'center', justifyContent:'center'}}>
                            <CardModal hsize={'80%'} icon2={false} icon1={false}>
                                <View style={{width:'100%', height:'100%'}}>
                                    <View style={{width:'90%',height:'60%', backgroundColor:'#252525', marginTop:15, borderRadius:16, shadowOffset:{width:10, height:5}, shadowRadius:10, shadowOpacity:0.5,borderColor:'#F9BA49', borderWidth:1.8, alignSelf:'center',alignItems:'center'}}>
                                        <Title color1={'#F9BA49'} value={'Vuoi salvare il Pg?'}/>
                                        <SubTitle color1={'#F9BA49'} value={'Confermando salveraì il Pg sul Database\n\n'}/>
                                        <Body  color1={'#F9BA49'} value={'Tranquillo potrai ancora modificarlo dal menù Managment.\n\nRicordati che per poter partecipare ai nostri eventi è necessario confemare definitivamente il Pg dal menù Managment'}/>
                                        <View style={{flexDirection:'row', justifyContent:'space-around', width:'90%', marginTop:100, alignSelf:'center', marginBottom:15,}}>
                                            <ButtonUser text={'Conferma'} wsize={'45%'} onPress={props.onPress1}/>
                                            <ButtonBlack text={'Annulla'} wsize={'45%'} onPress={props.onPress}/>
                                         </View>
                                    </View>
                                </View>
                            </CardModal>
                         </View>
            </Modal>);}

const CharacterConfirm = props =>{
    const [modalv, setModalv]= useState(props.modalv)
   
   
       return(
               <Modal
               visible={modalv}
               transparent={true}
               animationType={'slide'}
               key={props.key}
               style={{width:'100%', height:'100%',shadowOffset:{width:10, height:5}, shadowRadius:10, shadowOpacity:0.5,}}>
                            
                            <View style={{width:'100%', height:'100%', alignItems:'center', justifyContent:'center'}}>
                               <CardModal hsize={'80%'} icon2={false} icon1={false}>
                                   <View style={{width:'100%', height:'100%'}}>
                                       <View style={{width:'90%',height:'60%', backgroundColor:'#252525', marginTop:15, borderRadius:16, shadowOffset:{width:10, height:5}, shadowRadius:10, shadowOpacity:0.5,borderColor:'#F9BA49', borderWidth:1.8, alignSelf:'center',alignItems:'center'}}>
                                           <Title color1={'#F9BA49'} value={'Vuoi Confermare il Pg?'}/>
                                           <SubTitle color1={'#F9BA49'} value={'Confermando Salverai definitivamente il Pg sul Database\n\n'}/>
                                           <Body  color1={'#F9BA49'} value={'Da questo momento in poi, non sarà più possibile effettuare modifiche alla scheda, ma il Pg potra essere utilizzato per iscriversi agli Eventi.\n\n Non è possibile contattare la masterizzazione per effettuare ulteriori modifiche'}/>
                                           <View style={{flexDirection:'row', justifyContent:'space-around', width:'90%', marginTop:100, alignSelf:'center', marginBottom:15,}}>
                                               <ButtonUser text={'Conferma'} wsize={'45%'} onPress={props.onPress1}/>
                                               <ButtonBlack text={'Annulla'} wsize={'45%'} onPress={props.onPress}/>
                                            </View>
                                       </View>
                                   </View>
                               </CardModal>
                            </View>
               </Modal>);}

const CharacterConfirm1 = props =>{
    const [modalv, setModalv]= useState(props.modalv)
   
   
       return(
               <Modal
               visible={modalv}
               transparent={true}
               animationType={'slide'}
               key={props.key}
               style={{width:'100%', height:'100%',shadowOffset:{width:10, height:5}, shadowRadius:10, shadowOpacity:0.5,}}>
                            
                            <View style={{width:'100%', height:'100%', alignItems:'center', justifyContent:'center'}}>
                               <CardModal hsize={'80%'} icon2={false} icon1={false}>
                                   <View style={{width:'100%', height:'100%'}}>
                                       <View style={{width:'90%',height:'60%', backgroundColor:'#252525', marginTop:15, borderRadius:16, shadowOffset:{width:10, height:5}, shadowRadius:10, shadowOpacity:0.5,borderColor:'#F9BA49', borderWidth:1.8, alignSelf:'center',alignItems:'center'}}>
                                           <Title color1={'#F9BA49'} value={'Vuoi Confermare la MORTE del pg?'}/>
                                           <SubTitle color1={'#F9BA49'} value={'Confermando Ucciderai definitivamente il Pg sul Database\n\n'}/>
                                           <Body  color1={'#F9BA49'} value={'Da questo momento in poi, non sarà più possibile effettuare modifiche alla scheda.\n\n'}/>
                                           <View style={{flexDirection:'row', justifyContent:'space-around', width:'90%', marginTop:100, alignSelf:'center', marginBottom:15,}}>
                                               <ButtonUser text={'Conferma'} wsize={'45%'} onPress={props.onPress1}/>
                                               <ButtonBlack text={'Annulla'} wsize={'45%'} onPress={props.onPress}/>
                                            </View>
                                       </View>
                                   </View>
                               </CardModal>
                            </View>
               </Modal>);}


export  {CharacterSave, CharacterConfirm, CharacterConfirm1}